import { render, staticRenderFns } from "./ChildForm.vue?vue&type=template&id=628f3206&scoped=true"
import script from "./ChildForm.vue?vue&type=script&lang=js"
export * from "./ChildForm.vue?vue&type=script&lang=js"
import style0 from "./ChildForm.vue?vue&type=style&index=0&id=628f3206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f3206",
  null
  
)

export default component.exports